// extracted by mini-css-extract-plugin
module.exports = {"OrgFCListBase":"OrgFollowLikeFCList_OrgFCListBase__1hmLA","OrgFCListWrap":"OrgFollowLikeFCList_OrgFCListWrap__3Jikq"};